
var Model = require("../types/Model.js");
var xtend = require("xtend");

/**
 * Keeps track of the contact list, and the contacts' data
 * @type {Model}
 */
module.exports = Model({
	name: "managedatouchaway",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	_who: null,
	_who_tracker: null,
	_people: null,
	_group: null,

	refresh: refresh,
	reset: reset,
	sayViewing: sayViewing,
});

function init() {
	this._who = null;
	this._people = {};
	this._who_tracker = this.dispatcher.createTracker();
	this._group = null;

	this.reset();
}

/**
 * Removes all listeners from the dispatcher and the people store
 */
function uninit() {
	this._group = null;
	this._who = null;
	this._who_tracker.off(); //Ensures all trackers off off to ensure 'clean' start.
	this._who_tracker = null;
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"people:updated": handle_people_updated
	};
}

function triggers() {
	return {
		"update": update,
		"update:careplan": update_careplan,
		"view": view,
		"reset": trigger_reset,
	};
}

function view(data) {
	var who = data.who;
	var group = data.group;
	if(this._who === who) {
		this.sayViewing();
		return;
	}

	var managee = this._people[who];

	if (!managee) return; // Don't bother tracking if they don't exist

	// Track ID of person being managed
	this._who = who;

	this._group = group;

	var tracker = this._who_tracker;
	tracker.off(); //Ensures all trackers off to ensure 'clean' start.

	// Listen to changes in this person's data
	tracker.on("mqtt:u/" + who + "/atouchaway/updated", handle_update.bind(this));
	if(this._group)
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/atouchaway/updated", handle_update.bind(this));

	// Fetch the latest data
	this.refresh().then(sayViewing.bind(this));

	this.emit("usermetrics:trigger:track", "view managed user's atouchaway settings", {
		who: this._who,
	});
}

function sayViewing() {
	this.dispatch("viewing", {
		who: this._who,
		group: this._group
	});
}

function update(data) {
	var managee = this._who;
	var forms_sections = data.forms_sections;

	var payload = xtend(data, {
		no_power_button: !!data.no_power_button
	});

	if (forms_sections && Array.isArray(forms_sections)) {
		payload.forms_sections = forms_sections.reduce((acc, e) => {
			acc[e] = 2;
			return acc;
		}, {});
	} else if (forms_sections) {
		payload.forms_sections = Object.keys(forms_sections).reduce((acc, e) => {
			if (forms_sections[e])
				acc[e] = forms_sections[e];
			return acc;
		}, {});
	}

	var group = this._group;

	this.emit("save:trigger:start");
	this.api.manage.atouchaway
		.update(managee, payload, group)
		.then(handle_update_success.bind(this))
		.catch(handle_update_error.bind(this))
		.then(finish_load.bind(this));

	this.emit("usermetrics:trigger:track", "update managed user's atouchaway settings", {
		who: managee,
	});
}

function update_careplan(data) {
	update.call(this, {
		careplan_sections: data
	});
	this.emit("usermetrics:trigger:track", "update managed user's atouchaway careplan settings", {
		who: this._who,
	});
}

function handle_update_success() {
	this.dispatch("newatouchawaysettings", {
		who: this._who,
		section: "atouchaway",
		timestamp: new Date().toISOString(),
	});
	var message = "atouchawaysettings.saved";
	this.emit("toast:trigger:show", {
		content: message,
	});
}

function handle_update_error(error) {
	console.error(error);

	var message = "atouchawaysettings.error";
	this.emit("toast:trigger:show", {
		content: message,
		style: "error"
	});
}

function reset() {
	this.push({});
}

function trigger_reset(dontTrack) {
	dontTrack !== true && this.emit("usermetrics:trigger:track", "close managed user's atouchaway settings", {
		who: this._who,
	});
	this._who_tracker.off();
	this._who = null;
	this._group = null;
	this.reset();
}

function refresh() {
	var managee = this._who;
	if (!managee) return;
	this.reset();
	var group = this._group;

	this.emit("save:trigger:start");
	return this.api.manage.atouchaway
		.data(managee, group)
		.then(this.extend.bind(this))
		.catch(console.error.bind(console))
		.then(finish_load.bind(this));
}

function finish_load() {
	this.emit("save:trigger:finish");
}

function handle_update(data) {
	this.extend(data);
}

function handle_people_updated(people) {
	this._people = people;
}
